var SearchFiltersItem = require('./search-filter-tabs/search-filters-item');
var SearchFilterTabs = Marionette.CollectionView.extend({
    className: 'fmcy-search-filter-tabs clearfix',
    childView: SearchFiltersItem,
    childEvents: {
        'filter:clicked': 'onFilterClicked'
    },
    onBeforeShow: function() {
        var self = this;
        this.collection.each(function(model) {
            if (
                self.options.initialFilter &&
                self.options.initialFilter == model.get('slug')
            ) {
                var view = self.children.findByModel(model);
                if (view) {
                    view.setActive();
                }
            }
        });
    },
    onFilterClicked: function(childView) {
        var self = this;

        this.collection.each(function(model) {
            var view = self.children.findByModel(model);
            if (view) {
                view.reset();
            }
        });
        if (childView) {
            childView.setActive();
        }
        this.trigger('filter:clicked', childView.model);
    },
    setFilterActive: function(model) {
        var self = this;

        this.collection.each(function(model) {
            var view = self.children.findByModel(model);
            if (view) {
                view.reset();
            }
        });

        var childView = self.children.findByModel(model);
        if (!childView) {
            var selectedModel = this.collection.findWhere({
                name: model.get('name')
            });
            childView = self.children.findByModel(selectedModel);
        }
        if (childView) {
            childView.setActive();
        }
    },
    childViewOptions: function(model, index) {
        return {
            childIndex: index,
            totalItems: this.collection.length
        };
    },
    buildChildView: function(child, ChildViewClass, childViewOptions) {
        this.options.childIndex = childViewOptions.childIndex;
        this.options.totalItems = childViewOptions.totalItems;
        
        var options = _.extend({ model: child }, this.options);
        return new SearchFiltersItem(options);
    }
});


module.exports = SearchFilterTabs;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/subfilters/search-filters/search-filter-tabs.js
 **/